import { isNode } from "@pedrouid/environment";
export const isNodeJs = isNode;
export * from "@pedrouid/environment";
//# sourceMappingURL=env.js.map